import styled from 'styled-components';

import { borderColor, sectionColor } from '../../../lib/theme';

export const SelectorSurface = styled.div`
  border: 1px solid ${borderColor};
  border-radius: 4px;
  background: ${sectionColor};
  padding: 12px;
`;

export const SummaryLine = styled.div`
  margin-top: 10px;
  font-size: 12px;
  line-height: 1.4;
  color: rgba(0, 0, 0, 0.54);
`;
